import {default as deepMerge} from "deepmerge-json";
import {getCurrentTimeInMillis} from "../../utils";

export default class ControllerRequestBalancer {
    private _updates: { [id: string]: {controller: any} } = {};
    private _resolve: (state: { [id: string]: {controller: any} }) => any = () => {};
    private _last = 0;
    private _interval = 1000;

    private _settings = {
        requestsPerSecond: 30
    }
    constructor(resolve: (state: { [id: string]: {controller: any} }) => any, settings: { requestsPerSecond?: number }) {
        this._resolve = resolve;
        this._settings = deepMerge(this._settings, settings);
        this._interval = 1000 / this._settings.requestsPerSecond;
    }

    private static _now = () => getCurrentTimeInMillis();

    public memorize(id: string, controller: any) {
        if (this._updates[id]) {
            this._updates[id] = deepMerge(this._updates[id], {controller});
        } else {
            this._updates[id] = {controller};
        }
    }

    public go(id: string, controller: any) {
        let now = ControllerRequestBalancer._now();
        this.memorize(id, controller);

        if (now - this._last < this._interval) {
            setTimeout(() => {
                let now2 = ControllerRequestBalancer._now();
                if (now2 - this._last > this._interval) {
                    this._last = now2;
                    this.force();
                }
            }, this._interval - (now - this._last) + 25);
            return false;

        } else {
            this._last = now;
            this.force();

            return true;
        }
    }

    public force() {
        this._resolve(this._updates);
        this._updates = {};
    }
}